/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
"use client";
import { Box, Button, Stack, Typography } from "@mui/material";
import Link from "next/link";
import { SocialShare } from "../../components/FBSocial";
import Iconify from "../../components/Iconify";
import Markdown from "../../components/Markdown";
import useLocales from "../../hooks/useLocales";
import CommentList from "../comment/CommentList";
import CommentNewForm from "../comment/CommentNewForm";
import VideoPlayerPreview from "./VideoPlayerPreview";

export default function VideoSection({ currentItem, prevItem, nextItem }) {
  const { translate } = useLocales();

  return (
    <Stack sx={{ position: 'relative' }} >
      <VideoPlayerPreview video={currentItem} />
      <Stack spacing={2} px={currentItem?.id ? 0 : 1}>
        <Stack direction={"row"} spacing={1} justifyContent={"space-between"} alignItems={"center"}>
          <Link href={`/thi-duong-truong/${prevItem?.slug}`} passHref scroll={false}>
            <Button disabled={!prevItem} variant="outlined" size="large" startIcon={<Iconify icon={'material-symbols:arrow-back-ios'} />} />
          </Link>
          <Typography variant="h6" color={"primary"} >{currentItem?.title}</Typography>
          <Link href={`/thi-duong-truong/${nextItem?.slug}`} passHref scroll={false}>
            <Button disabled={!nextItem} variant="outlined" size="large" endIcon={<Iconify icon={'material-symbols:arrow-forward-ios'} />} />
          </Link>
        </Stack>
        <div className="ql-snow">
          <div className="ql-editor" style={{ padding: 0 }}>
            <Markdown children={currentItem?.description} />
          </div>
        </div>

        <SocialShare title={currentItem?.title} />

        <Box sx={{ display: 'flex', mb: 2 }}>
          <Typography variant="h4">{translate("button.comment")}</Typography>
        </Box>
        <CommentNewForm itemId={currentItem?.orderNo} type="STREETEXAM" />
        <CommentList />
      </Stack>
    </Stack>
  );
}